import React from 'react';

import {
  GetExtendedSalesInvoiceDto,
  GetProjectDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import { AttachmentId } from './useSalesInvoiceData';
import { SalesInvoiceHeaderTitle } from './SalesInvoiceHeaderTitle';
import { SalesInvoiceHeaderProjects } from './SalesInvoiceHeaderProjects';
import { SalesInvoiceHeaderInfo } from './SalesInvoiceHeaderInfo';

interface SalesInvoiceHeaderProps {
  isInActive?: boolean;
  salesInvoice?: GetExtendedSalesInvoiceDto;
  projects: GetProjectDto[];
  attachmentIds?: AttachmentId[];
  goToProject: (id: string) => void;
  goToSalesInvoice: (id: string) => void;
  onPrintInvoice?: () => void;
  onPreviewInvoice?: () => void;
}

export const SalesInvoiceHeader: React.FC<SalesInvoiceHeaderProps> = ({
  isInActive,
  salesInvoice,
  projects,
  attachmentIds,
  goToProject,
  goToSalesInvoice,
  onPrintInvoice,
  onPreviewInvoice,
}) => (
  <>
    <SalesInvoiceHeaderTitle
      isInActive={isInActive}
      salesInvoice={salesInvoice}
      goToSalesInvoice={goToSalesInvoice}
      onPrintInvoice={onPrintInvoice}
      onPreviewInvoice={onPreviewInvoice}
    />
    <ul className="sales-invoice-header-list small fw-normal">
      <SalesInvoiceHeaderProjects
        projects={projects}
        attachmentIds={attachmentIds}
        goToProject={goToProject}
      />
      {salesInvoice && (
        <SalesInvoiceHeaderInfo
          salesInvoice={salesInvoice}
          goToSalesInvoice={goToSalesInvoice}
        />
      )}
    </ul>
  </>
);
